import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import { Button } from '../../../components/button'
import { useParams, Link } from "react-router-dom";
import PaymentProcessorForm from '../../../components/forms/payment-processor-form';
import { getPaymentProcessorDetail } from '../../../slices/paymentprocessors';

const PaymentProcessorEdit = () => {

    const {id} = useParams()
    const dispatch = useDispatch()
    const selectedPaymentProcessor = useSelector((state) => state.paymentprocessors.selectedPaymentProcessor)

    useEffect(() => {
        dispatch(getPaymentProcessorDetail(id))
    }, [id])

    const [showPaymentProcessor, setShowPaymentProcessor] = useState(false)

    useEffect(() => {
        if (selectedPaymentProcessor && selectedPaymentProcessor.id === parseInt(id)) {
            setShowPaymentProcessor(true)
        } else {
            setShowPaymentProcessor(false)
        }
    }, [selectedPaymentProcessor])

    return (
        <>
            <div className="container-fluid">
                <div className="row clamped">
                    <div className="col px-0 settings-header flex-wrap">
                        <h1 className="title">{selectedPaymentProcessor?.name}</h1>
                        <Link to={"/settings/paymentprocessors"}><Button variant={"secondary"} size={"sm"}>{gettext('Cancel')}</Button></Link>
                    </div>
                </div>
            </div>
            { showPaymentProcessor &&
                <PaymentProcessorForm paymentProcessor={selectedPaymentProcessor} />
            }
        </>
    )
}

export default PaymentProcessorEdit